import {
  Component,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { getMessageSenderLabel } from 'src/app/forms/messageForms';
import { IMessage } from 'src/app/models';
import { CommunicationUserType } from 'src/app/models/enums';
import { MessageChannel } from 'src/app/models/enums/messageChannel';
import { LiteralService, UtilsService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { IMessagesState } from 'src/app/store/states';
import { images } from 'src/images';

@Component({
  selector: 'app-messages-table',
  templateUrl: './messages-table.component.html',
  styleUrl: './messages-table.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class MessagesTableComponent {
  readonly messages = input<IMessagesState>();
  readonly userType = input<CommunicationUserType>(CommunicationUserType.USERS);
  readonly selectedMessageId = input<number>();
  readonly selectMessage = output<any>();
  readonly selectMessageDetail = output<any>();

  public images = images;
  public CommunicationUserType = CommunicationUserType;
  public TooltipPosition = TooltipPosition;
  public MessageChannel = MessageChannel;

  constructor(
    public literalService: LiteralService,
    public utilsService: UtilsService,
  ) {}

  getSenderLabel(message: IMessage): string {
    return getMessageSenderLabel(message, this.literalService);
  }

  showMessageData(id: number) {
    this.selectMessage.emit(id);
  }

  openMessage(event: MouseEvent, id: number) {
    if (event.ctrlKey || event.metaKey || event.shiftKey) return;
    event.preventDefault();
    this.showMessageData(id);
  }

  showMessageDetail(id: number) {
    this.selectMessageDetail.emit(id);
  }
}
